module.exports = __webpack_public_path__ + "img/warning_w.8b8e8c39.svg";